var map = {
	"./de_DE.json": 1039,
	"./en_AU.json": 1040,
	"./en_CA.json": 1041,
	"./en_GB.json": 1042,
	"./es_AR.json": 1043,
	"./es_ES.json": 1044,
	"./es_MX.json": 1045,
	"./fr_CA.json": 1046,
	"./fr_FR.json": 1047,
	"./it_IT.json": 1048,
	"./nl_NL.json": 1049,
	"./pt_BR.json": 1050,
	"./pt_PT.json": 1051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1038;